import { Component, OnInit, Input, AfterViewInit, OnChanges } from '@angular/core';

@Component({
  selector: 'app-sts-show-error',
  templateUrl: './sts-show-error.component.html',
  styleUrls: ['./sts-show-error.component.scss']
})
export class StsShowErrorComponent implements OnInit {

  @Input() show = false;
  @Input() key = 'sts-generic-error';
  @Input() description = 'Error';

  constructor() { }

  ngOnInit() {
  }
}
